<template>
    <v-row>
        <v-col cols="12" style="padding: 0px">
            <v-row class="text-right">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                                color="blue-grey"
                                dark
                                style="margin: 1px"
                                v-bind="attrs"
                                v-on="on"
                        >
                            تعاریف
                        </v-btn>
                    </template>
                    <v-list style="text-align: right;">
                        <v-list-item @click="$router.push({path:'/origin-download'})">
                            <v-list-item-title >مبدا بارگیری</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({path:'/load-type'})">
                            <v-list-item-title >نوع جنس بار</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({path:'/add-truck'})">
                            <v-list-item-title>اطلاعات کامیون</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="$router.push({path:'/add-discharge-place'})">
                            <v-list-item-title>محل تخلیه</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="$router.push({path:'/tonaje_limit'})">
                            <v-list-item-title>سقف تناژ</v-list-item-title>
                        </v-list-item>

                    </v-list>
                </v-menu>
<!--                <v-menu offset-y>-->
<!--                    <template v-slot:activator="{ on, attrs }">-->
<!--                        <v-btn-->
<!--                                color="blue-grey"-->
<!--                                dark-->
<!--                                style="margin: 1px"-->
<!--                                v-bind="attrs"-->
<!--                                v-on="on"-->
<!--                        >-->
<!--                            خرید و تحویل-->
<!--                        </v-btn>-->
<!--                    </template>-->
<!--                    <v-list>-->
<!--                        <v-list-item  @click="$router.push({path:'/price-buy-delivery'})">-->
<!--                            <v-list-item-title>نرخ خرید و تحویل بار</v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                        <v-list-item @click="$router.push({path:'/report-price-buy-delivery'})" >-->
<!--                            <v-list-item-title>گزارش خرید و تحویل بار</v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                    </v-list>-->
<!--                </v-menu>-->
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                                color="blue-grey"
                                dark
                                style="margin: 1px"
                                v-bind="attrs"
                                v-on="on"
                        >
                            اسناد حمل و نقل
                        </v-btn>
                    </template>
                    <v-list  style="text-align: right;">
                        <v-list-item @click="$router.push({path:'/insert-delivery-document'})" >
                            <v-list-item-title>ورود اسناد حمل و نقل</v-list-item-title>
                        </v-list-item>
<!--                        <v-list-item>-->
<!--                            <v-list-item-title>اصلاح و حذف اسناد حمل و نقل</v-list-item-title>-->
<!--                        </v-list-item>-->
                        <v-list-item @click="$router.push({path:'/report-delivery-document'})">
                            <v-list-item-title>جستجوی اسناد حمل و نقل</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                                color="blue-grey"
                                dark
                                style="margin: 1px"
                                v-bind="attrs"
                                v-on="on"
                        >
                            گزارشات
                        </v-btn>
                    </template>
                    <v-list style="text-align: right;">
                        <v-list-item  @click="$router.push({path:'/report-driver-detail'})">
                            <v-list-item-title>گزارش کارکرد کامیون داران</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({path:'/report-delivery-load-detail'})">
                            <v-list-item-title>خلاصه مالی صورت وضعیت حمل بار</v-list-item-title>
                        </v-list-item>
<!--                        <v-list-item  @click="$router.push({path:'/list-delivery-load'})">-->
<!--                            <v-list-item-title>لیست بار های حمل شده</v-list-item-title>-->
<!--                        </v-list-item>-->
                        <v-list-item @click="$router.push({path:'/report-all-list-delivery-load'})" >
                            <v-list-item-title>گزارش کلی اسناد حمل و نقل</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                                color="blue-grey"
                                dark
                                style="margin: 1px"
                                v-bind="attrs"
                                v-on="on"
                        >
                            امکانات جانبی
                        </v-btn>
                    </template>
                    <v-list style="text-align: right;">
<!--                        <v-list-item>-->
<!--                            <v-list-item-title>پشتیبان گیری</v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                        <v-list-item>-->
<!--                            <v-list-item-title>بازیابی پشتیبان</v-list-item-title>-->
<!--                        </v-list-item>-->
                        <v-list-item @click="$router.push({path:'/users'})">
                            <v-list-item-title>کاربران سیستم</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({path:'/signatures'})">
                            <v-list-item-title>لیست امضا</v-list-item-title>
                        </v-list-item>
<!--                        <v-list-item>-->
<!--                            <v-list-item-title>انتقال اطلاعات</v-list-item-title>-->
<!--                        </v-list-item>-->
                        <v-list-item>
                            <v-list-item-title>اسناد پیشنویس</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
<!--                <v-menu offset-y>-->
<!--                    <template v-slot:activator="{ on, attrs }">-->
<!--                        <v-btn-->
<!--                                color="blue-grey"-->
<!--                                dark-->
<!--                                style="margin: 1px"-->
<!--                                v-bind="attrs"-->
<!--                                v-on="on"-->
<!--                        >-->
<!--                            مساعده-->
<!--                        </v-btn>-->
<!--                    </template>-->
<!--                    <v-list style="text-align: right;">-->
<!--                        <v-list-item  @click="$router.push({path:'/insert-pre-payment'})">-->
<!--                            <v-list-item-title>پرداخت و اصلاح مساعده</v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                        <v-list-item  @click="$router.push({path:'/report-pre-payment'})">-->
<!--                            <v-list-item-title>گزارش پرداخت مساعده</v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                    </v-list>-->
<!--                </v-menu>-->
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                                color="blue-grey"
                                dark
                                style="margin: 1px"
                                v-bind="attrs"
                                v-on="on"
                        >
                            اطلاعات شرکت
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="$router.push({path:'/settings'})">
                            <v-list-item-title>اطلاعات شرکت</v-list-item-title>
                        </v-list-item>
                    </v-list><v-list>
                        <v-list-item @click="$router.push({path:'/accounting-year'})">
                            <v-list-item-title>سال مالی</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-row>
        </v-col>
        <v-col cols="12" style="padding: 5px">

                <v-row class="text-right">
                        <img class="nav-buttons" :src="refresh_image" title="اسناد پیش نویس"/>
                    <img class="nav-buttons" :src="exchange_image" title="انتقال اطلاعات اسناد"/>
<!--                    <img class="nav-buttons" :src="save_image" title="بازیابی پشتیبان"/>-->
<!--                    <img class="nav-buttons" :src="backup_image" title="پشتیبان گیری"/>-->

                    <img class="nav-buttons" @click="$router.push({path:'/report-all-list-delivery-load'})" :src="card_image" title="گزارش کلی اسناد حمل و نقل"/>
                    <img @click="$router.push({path:'/report-driver-detail'})" class="nav-buttons" :src="cards_image" title="گزارش ریز کارکرد کامیون داران"/>
                    <img class="nav-buttons" :src="chart_image" title="خلاصه صورت وضعیت حمل بار" @click="$router.push({path:'/report-delivery-load-detail'})"/>
                    <img class="nav-buttons" :src="chart2_image" title="لیست بارهای حمل شده"  @click="$router.push({path:'/list-delivery-load'})"/>

                    <img @click="$router.push({path:'/report-delivery-document'})" class="nav-buttons" :src="chart3_image" title="گزارش اسناد حمل و نقل"/>
<!--                    <img class="nav-buttons" :src="agreement_image" title="اصلاح اطلاعات اسناد"/>-->
                    <img  @click="$router.push({path:'/insert-delivery-document'})" class="nav-buttons" :src="documents_image" title="ورود اطلاعات اسناد"/>

                    <img @click="$router.push({path:'add-discharge-place'})" class="nav-buttons" :src="download_image" title="محل تخلیه"/>
                    <img @click="$router.push({path:'add-truck'})" class="nav-buttons" :src="truck_image" title="اطلاعات کامیون"/>
                    <img @click="$router.push({path:'load-type'})" class="nav-buttons" :src="notes_image" title="نوع جنس بار"/>
                    <img @click="$router.push({path:'origin-download'})" class="nav-buttons" :src="upload_image" title="مبدا بارگیری"/>
                </v-row>
        </v-col>
    </v-row>
</template>

<script>
    import card from '@/assets/icons/card.png'
    import cards from '@/assets/icons/cards.png'
    import chart from '@/assets/icons/chart.png'
    import chart2 from '@/assets/icons/chart2.png'
    import chart3 from '@/assets/icons/chart3.png'
    import download from '@/assets/icons/download.png'
    import notes from '@/assets/icons/notes.png'
    import refresh from '@/assets/icons/refresh.png'
    import save from '@/assets/icons/save.png'
    import truck from '@/assets/icons/truck.png'
    import upload from '@/assets/icons/upload.png'
    import exchange from '@/assets/icons/exchange.png'
    import backup from '@/assets/icons/backup.png'
    import documents from '@/assets/icons/documents.png'
    import agreement from '@/assets/icons/agreement.png'

    export default {
        name: 'navbar',
        components: {},
        data () {
            return {
                card_image: card,
                cards_image: cards,
                chart_image: chart,
                chart2_image: chart2,
                chart3_image: chart3,
                download_image: download,
                notes_image: notes,
                refresh_image: refresh,
                save_image: save,
                truck_image: truck,
                upload_image: upload,
                exchange_image: exchange,
                backup_image: backup,
                documents_image: documents,
                agreement_image: agreement,
            }
        },
        mounted () {
            // this.saveFile()
        },
        methods: {}
    }
</script>
<style>
    .nav-buttons{
        width: 40px!important;
        height: 40px!important;
        border: 1px solid black;
        border-radius: 3px;
        padding: 5px;
        margin: 5px;
    }
</style>
